import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Cuánto cuesta el website?',
  a: '$250 pago único. Sin mensualidades obligatorias. Sin costos ocultos.'
}, {
  q: '¿Por qué es tan barato?',
  a: 'Porque nos especializamos solo en contractors y tenemos un proceso súper eficiente: usamos una estructura comprobada que adaptamos a tu negocio, sin agencias caras de por medio ni meses de trabajo. Preferimos cobrar accesible y ganar por volumen y referidos, no inflando el precio. Mismo resultado profesional, sin el costo de una agencia tradicional.'
}, {
  q: '¿Cuánto necesito para empezar?',
  a: 'Solo $125 — el 50% por adelantado para apartar tu lugar y comenzar a trabajar.'
}, {
  q: '¿Cuándo pago el resto?',
  a: 'El otro $125 lo pagas cuando veas tu website terminado y estés satisfecho.'
}, {
  q: '¿Hay mensualidades?',
  a: 'No hay mensualidades obligatorias. Ofrecemos un plan opcional de mantenimiento por $30/mes si lo deseas.'
}, {
  q: '¿Qué incluye el mantenimiento de $30?',
  a: 'Actualización de fotos, cambios de contenido, soporte técnico y comunicación directa por WhatsApp.'
}, {
  q: '¿Cuánto tiempo tarda?',
  a: 'Menos de 72 horas una vez que tengamos toda la información de tu negocio.'
}, {
  q: '¿Qué información necesitan?',
  a: 'Nombre del negocio, servicios, fotos, número de contacto, área de servicio y cualquier detalle importante.'
}, {
  q: '¿Cómo los contacto?',
  a: 'Por WhatsApp al +44 7311 754270 — escríbenos "WEBSITE" y te atendemos hoy.'
}, {
  q: '¿Trabajan con todos los contractors?',
  a: 'Sí — roofing, landscaping, tree service, construcción, pressure washing, HVAC, plomería, junk removal y más.'
}, {
  q: '¿Qué pasa si no me gusta el diseño?',
  a: 'Hacemos revisiones hasta que lo ames — no pagas el resto hasta estar satisfecho.'
}, {
  q: '¿Necesito saber algo técnico?',
  a: 'Absolutamente no. Nosotros manejamos todo. Tú solo nos das la información y apruebas el resultado.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-dark" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4">
            ¿Tienes Preguntas?{' '}
            <span className="text-gold" data-id="element-5">Tenemos Respuestas.</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-6">
          {faqs.map((faq, index) => <div key={index} className="bg-dark-100 border border-white/10 rounded-2xl overflow-hidden transition-all duration-300" data-id="element-7">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-8">
                <span className="text-white font-bold pr-8" data-id="element-9">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gold shrink-0" data-id="element-10" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0" data-id="element-11" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12">
                <p className="text-gray-400 text-sm border-t border-white/5 pt-4" data-id="element-13">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}